import "../assets/index-0ac09203.css";
import r from "./NcButton.mjs";
import { n as i } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const o = {
  components: {
    NcButton: r
  },
  props: {
    buttonId: {
      type: String,
      required: !1,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    text: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "primary",
      validator(e) {
        return ["primary", "secondary", "tertiary"].indexOf(e) !== -1;
      }
    }
  },
  emits: ["click"]
};
var a = function() {
  var t = this, n = t._self._c;
  return n("div", { staticClass: "app-navigation-new" }, [n("NcButton", { attrs: { id: t.buttonId, disabled: t.disabled, type: t.type }, on: { click: function(l) {
    return t.$emit("click");
  } }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t._t("icon")];
  }, proxy: !0 }], null, !0) }, [t._v(" " + t._s(t.text) + " ")])], 1);
}, c = [], s = /* @__PURE__ */ i(
  o,
  a,
  c,
  !1,
  null,
  "c47dc611",
  null,
  null
);
const _ = s.exports;
export {
  _ as default
};
